// extracted by mini-css-extract-plugin
export var questionBox = "_aq-0";